import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import Localizer from "@Scripts/Common/Localizer";
import GTagHelper from "@Scripts/Infrastructure/GTagHelper";

@Component({ name: "Feedback" })
export default class Feedback extends Vue {
    public localizer: any = Localizer;
    public isRating: boolean = true;
    public isPositiveRating: boolean = false;
    public isNegativeRating: boolean = false;
    public isSuccess: boolean = false;

    @Prop() readonly pageDetail: boolean;
    @Prop() readonly isCatalogue: boolean;

    get routes() {
        return (<any>window).App.routes;
    }

    public setFeedbackRating(rating: boolean) {
        if (rating) {
            this.isPositiveRating = true;
        } else {
            this.isNegativeRating = true;
        }
        this.isRating = false;
        GTagHelper.sendEvent("click", "feedback", this.isPositiveRating ? "yes" : "no");
    }

    public setFeedbackOpinion(opinion: string) {
        GTagHelper.sendEvent("click", "feedback", this.isPositiveRating ? "like_" + opinion : "dislike_" + opinion)

        this.isPositiveRating = false;
        this.isNegativeRating = false;
        this.isSuccess = true;
    }
};